import { render, staticRenderFns } from "./addBlackInvoice.vue?vue&type=template&id=ff732ca0"
import script from "./addBlackInvoice.vue?vue&type=script&lang=js"
export * from "./addBlackInvoice.vue?vue&type=script&lang=js"
import style0 from "./addBlackInvoice.vue?vue&type=style&index=0&id=ff732ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports